( function( $ ) {

    const pdpChangePosition = () => {
        if (!$('.single-product').length || !$("[data-position-product-title-mobile]").length || !$("[data-position-product-title-desktop]").length || !$("[data-position-single-add-to-cart-mobile]").length || !$("[data-single-add-to-cart-desktop]").length) {
            return false;
        }

        if ($(window).width() < 992) {
            $('[data-position-product-title-desktop]').contents().appendTo('[data-position-product-title-mobile]');
            $('[data-single-add-to-cart-desktop]').contents().appendTo('[data-position-single-add-to-cart-mobile]');
        }

        if(!($(window).width() < 992) && $('[data-position-product-title-desktop]:empty').length) {
            $('[data-position-product-title-mobile]').contents().appendTo('[data-position-product-title-desktop]');
        }

        if(!($(window).width() < 992) && $('[data-single-add-to-cart-desktop]:empty').length) {
            $('[data-position-single-add-to-cart-mobile]').contents().appendTo('[data-single-add-to-cart-desktop]');
        }
    }

    if ($('.single-product').length) {
        pdpChangePosition();
        $(window).resize(pdpChangePosition);
    }


    $('.read-toggle').on('click', function() {
        var contentWrap = $(this).parents().find('.content-wrapper');
        var shortContent = contentWrap.find('.short-content');
        var completeContent = contentWrap.find('.complete-content');

        if($(this).hasClass('read-more')) {
            shortContent.hide();
            completeContent.show();
        }

        if($(this).hasClass('read-less')) {
            completeContent.hide();
            shortContent.show();
        }
    });


    // add data attribute on selecting a star for gtm 
    $('body').on('click', '#respond p.stars a', function() {
        $(this).siblings('a').attr("data-gtm-rating", "");
        $(this).attr("data-gtm-rating", "selected");

        return false;
    });
    

    document.addEventListener('DOMContentLoaded', () => {

        if (document.querySelector('#review-form-container')) {
            var review_form_waypoint = new Waypoint({
                element: $('#review-form-container'),
                handler: function(direction) {
                    document.querySelector('.single_variation_wrap ').classList.toggle('slide-out');
                }, 
                offset: 550 
            })
        }

        // set the star selected in the email as selected in the review form
        if (document.querySelector('[data-selected-star]')) {
            const elem = document.querySelector('[data-selected-star]');
            let star_rating = elem.dataset.selectedStar;

            // the Woocommerce JS adds the click event listener after DOM loaded so wait a second or 2 to trigger it or it won't work
            if (star_rating) {
                setTimeout(() => {
                    document.querySelector('#commentform .stars a.star-' + star_rating).click();
                }, 2000);
            }
        }


        // The bootstrap collapse functionality didn't work properly so i made this simple version for now
        if (document.querySelector('[data-review-text-toggle]')) {
            document.querySelector('[data-review-text-toggle]').addEventListener('click', (event) => {
                event.preventDefault();

                let toggle_el = event.target;
                let target = document.querySelector(event.target.dataset.reviewTextTarget);

                if (target.dataset.toggleStatus == 'inprogress') {
                    return false;
                }

                target.dataset.toggleStatus = 'inprogress';

                if (target.classList.contains('open')) {
                    toggle_el.classList.remove('open');

                    $(target).slideUp(250, (e) => {
                        target.classList.remove('open');
                        target.dataset.toggleStatus = '';
                        target.setAttribute('aria-expanded', false);
                    });
                } else {
                    toggle_el.classList.add('open');

                    $(target).slideDown(250, (e) => {
                        target.classList.add('open');
                        target.dataset.toggleStatus = '';
                        target.setAttribute('aria-expanded', true);
                    });
                }
            });
        }


        // Basic load more for product reviews, might be improved later with an actual load more, this is for the MVP
        if (document.querySelector('[data-review-load-more]')) {
            document.querySelector('[data-review-load-more]').addEventListener('click', (event) => {

                event.preventDefault();

                let reviews = document.querySelectorAll(".commentlist .review.d-none");
                
                reviews.forEach(item => {
                    item.classList.remove('d-none');
                });

                event.target.parentNode.classList.add('d-none');
            });
        }
    });



    //Take control of slider if Vimeo video is added
    if ($(".carousel-item-video").length) {
        const videos = document.querySelectorAll(".carousel-item-video");

        if (!videos) {
            return;
        }

        $('.video-mask').on('click', function(e) {
            new Vimeo.Player($(this).parent().find('iframe')).play();
            $(this).hide();
            $("#single-product-carousel").carousel("pause");
        });
        
        $(".carousel").on("slide.bs.carousel", function(e) {

            $('.carousel-item-video iframe').each((index, video) => {
                new Vimeo.Player(video).pause();
            });
            $('.video-mask').show();
            $("#single-product-carousel").carousel("cycle");
        });
    }

    $(".carousel").on("slide.bs.carousel", function(e) {

        if ($('[data-product-carousel-indicator-item]').length) {
            $('[data-product-carousel-indicator-item]').removeClass('active');
            $('[data-product-carousel-indicator-item="' + e.to + '"]').addClass('active');
        }
    });

    // variant selector hover title effect
    $(".product-variant").on("mouseover", function(e) {
        let variantTitle = $(this).data('product-variant-image-title');
        $('.product-variant-title').text(variantTitle);

        let variantId = $(this).data('product-variant-image-id');
        let thumbnailsHeight = $(".product-carousel-indicators-container").height() + 16;
        $('[data-product-variant-images]').css("bottom", thumbnailsHeight);
        $('#' + variantId).removeClass("d-none");
    });

    $(".product-variant").on("mouseout", function(e) {
        let variantTitle = $(".product-variant:first-child").data('product-variant-image-title');
        $('.product-variant-title').text(variantTitle);

        let variantId = $(this).data('product-variant-image-id');
        $('#' + variantId).addClass("d-none");
        $('[data-product-variant-images]').css("bottom", "");
    });

} )( jQuery );